import type { PresentationModule } from '../../../presentation/types';
import { mintCore, mintIntelligence, mintSpecialisation, mintDirections } from './content';
import { MintCoreScene } from './scenes/MintCoreScene';
import { MintIntelligenceScene } from './scenes/MintIntelligenceScene';
import { MintSpecialisationScene } from './scenes/MintSpecialisationScene';
import { MintDirectionsScene } from './scenes/MintDirectionsScene';

const SPECIALISATIONS = ['mint-it', 'mint-travel', 'mint-business'] as const;

export const mintModule: PresentationModule = {
  id: 'mint',
  label: 'MINT',
  priority: 'flagship',
  scenes: [
    { ...mintCore, module: 'mint', create: (resolved) => new MintCoreScene(resolved) },
    { ...mintIntelligence, module: 'mint', create: (resolved) => new MintIntelligenceScene(resolved) },
    { ...mintSpecialisation, module: 'mint', requiresAny: [...SPECIALISATIONS], create: (resolved) => new MintSpecialisationScene(resolved) },
    { ...mintDirections, module: 'mint', requiresAny: [...SPECIALISATIONS], create: (resolved) => new MintDirectionsScene(resolved) },
  ],
};
